module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_bg03-32286e683d2182278d643657835233cd.jpg";